import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  climaLog: null,
  climaLogError: "",
};

export default function ClimaLogReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CLIMA_LOG:
      return { ...state, loading: action.payload };
    case actions.GET_CLIMA_LOG:
      return { ...state, climaLog: action.payload };
    case actions.CLIMA_LOG_FAIL:
      return { ...state, climaLogError: action.payload };
    default:
      return state;
  }
}
